import React, { ReactNode } from 'react';
import {
  makeStyles,
  Theme,
  createStyles,
  Card,
  CardContent,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { IReduxState } from '../../../types';
import { SkeletonLoaderCardSmall } from '../SkeletonLoaders/';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      zIndex: 1,
      flexGrow: 1,
    },
    card: {
      height: 500,
      [theme.breakpoints.up('xs')]: {
        margin: `${theme.spacing(4)}px 0`,
      },
      [theme.breakpoints.up('sm')]: {
        margin: `${theme.spacing(2)}px`,
      },
    },
    cardContent: {
      height: '100%',
      [theme.breakpoints.up('md')]: {
        padding: `${theme.spacing(2)}px 0`,
      },
    },
    actionsArena: {
      position: 'relative',
      height: '100%',
      paddingTop: 0,
      paddingBottom: '0!important' as any,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacing(4),
      },
    },
  })
);

export interface ICardLayoutProps {
  cardStyle?: React.CSSProperties;
  children: ReactNode;
};

export default function CardLayout(props: ICardLayoutProps){
  const classes = useStyles();

  const isFetchingTelemetry = useSelector(
    (state: IReduxState) => state.machineDetails.isFetchingTelemtry
  );

  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <Card 
          className={classes.cardContent}
          style={props.cardStyle}
        >
          <CardContent
            className={classes.actionsArena}
            style={{
              paddingTop: isFetchingTelemetry ? '1rem' : '2rem',
            }}
          >
            {
              isFetchingTelemetry 
                ? <SkeletonLoaderCardSmall />
                : props.children
            }
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
